import React from "react";
import { Navigate } from "react-router-dom";

export default function RoleBasedRedirect() {
  const tokenPayload = JSON.parse(localStorage.getItem("tokenPayload"));
  const token = localStorage.getItem("token");

  // If there is no token, route to the unified login page
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (token && tokenPayload?.role === "doctor") {
    return <Navigate to="/admin/doctor" replace />;
  }
  if (token && tokenPayload?.role === "frontdesk") {
    return <Navigate to="/admin/appointments" replace />;
  }

  // default for authenticated users without a recognized role
  return <Navigate to="/admin" replace />;
}